import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import produce from 'immer'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'

import { Invoice, InvoiceItem } from '../../../../../../data/models'
import {
  isRowSelectable,
  rowClassName,
} from '../../../../../../utils/helper/isRowSelectable'
import { ConfigurableTable } from '../../../../../../utils/wrapper'
import { useConfigContext } from '../../../../../ui-config/context'

type Props = {
  setInfoModus: (params: boolean) => void
  setDisplayInfoItem: (params: boolean) => void
  setDisplayInfoItemAllowanceCharge: (params: boolean) => void
  setIdInfoItemAllowanceCharge: (params: string) => void
  setInfoActiveTabViewPanelIndex: (params: number) => void
  currency: Invoice['OrderCurrency']
  data: InvoiceItem['AllowanceCharges']
}

export const AllowanceCharges: React.FC<Props> = ({
  setInfoModus,
  setDisplayInfoItem,
  setDisplayInfoItemAllowanceCharge,
  setIdInfoItemAllowanceCharge,
  setInfoActiveTabViewPanelIndex,
  currency,
  data,
}) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()

  // get items for rejecting or accepting
  const [selectedItems, setSelectedItems] = useState<InvoiceItem[] | null>()

  const convertedAllowanceCharges = produce(data, draft => {
    draft?.forEach(allowanceCharge => {
      // description
      allowanceCharge.ConfirmationDescription =
        allowanceCharge.ConfirmationDescription ||
        allowanceCharge.Description?.Text
    })
  })

  const headerTitle = t(
    'invoice.invoiceItems.table.info.dialog.allowanceCharges.table.title',
  )

  //  action template
  const actionBodyTemplate = (rowData: any) => {
    return (
      <>
        <div className="flex justify-content-end flex-nowrap">
          <Button
            icon="pi pi-info-circle"
            className="p-button-rounded p-button-text mr-2"
            onClick={() => {
              setDisplayInfoItem(false)
              setIdInfoItemAllowanceCharge(rowData.Id)
              setInfoModus(true)
              setDisplayInfoItemAllowanceCharge(true)
              setInfoActiveTabViewPanelIndex(1)
            }}
            visible={
              config.invoice.infoInvoiceItemAllowanceCharge.enabled !== false
            }
          />
        </div>
      </>
    )
  }

  const buttons = (
    <Column key="buttons" body={actionBodyTemplate} align="right"></Column>
  )

  return (
    <ConfigurableTable
      config={config.invoice.infoInvoiceItem.allowanceCharges.table}
      data={convertedAllowanceCharges}
      buttons={buttons}
      headerTitle={headerTitle}
      selected={selectedItems}
      setSelected={setSelectedItems}
      isDataSelectable={isRowSelectable}
      rowClassName={rowClassName}
      stateKey=""
    />
  )
}
